const beneficiaries = [
  {
    name: "Aarohi",
    age: 12,
    story: "Aarohi came to Sitaare at age 10. With support, she’s now excelling in school and dreams of becoming a doctor.",
    quote: "At Sitaare, I found a family and the courage to dream big.",
    image: "https://via.placeholder.com/120x120?text=Aarohi",
  },
  {
    name: "Meera",
    age: 15,
    story: "Meera discovered her love for art at Sitaare. She now leads the art club and inspires others.",
    quote: "Here, I learned that my voice and my art matter.",
    image: "https://via.placeholder.com/120x120?text=Meera",
  },
  {
    name: "Sana",
    age: 10,
    story: "Sana overcame her shyness and now participates in school debates and sports, thanks to the encouragement at Sitaare.",
    quote: "Sitaare helped me believe in myself.",
    image: "https://via.placeholder.com/120x120?text=Sana",
  },
];

export default beneficiaries; 